module.exports = __webpack_public_path__ + "static/media/Play.6e3b5df7.svg";